import { useColors } from "../../hooks/colors/useColors";
import { Stepper } from "@mantine/core";
import { Container } from "../../components/UI/container/Container";
import { ThirdStep } from "../../components/pages/user/appointments/new-appointment/ThirdStep";
import { bookingStore } from "../../components/config/store/bookingStore";
import { FourthStep } from "../../components/pages/user/appointments/new-appointment/FourthStep";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { isMobile } from "react-device-detect";
import { MyHead } from "../../components/pages/MyHead";
import { Fragment } from "react";
import { BackToProfile } from "../../components/pages/user/BackToProfile";
import { isPhone } from "../../constants/env";
import { FirstStep } from "../../components/pages/user/appointments/new-appointment/FirstStep";
import { SecondStep } from "../../components/pages/user/appointments/new-appointment/SecondStep";
import { Footer } from "../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function BookingPage() {
  const { colors } = useColors();
  const { activeIndex, stepperFields } = bookingStore((state) => state);
  const { t } = useTranslation("common");

  return (
    <Fragment>
      <MyHead
        title={t("appointments.bookAppointment")}
        description={t("appointments.bookAppointment")}
      />
      <BackToProfile />
      <Container noHeight>
        <Stepper
          className={isPhone ? "mt-4" : ""}
          orientation={isMobile ? "vertical" : "horizontal"}
          radius={50}
          iconSize={isPhone ? 40 : 80}
          active={activeIndex}
          // breakpoint="xl"
          color={colors.primary}
          styles={{
            stepWrapper: {
              // height: isMobile ? 20 : undefined,
              // width: isMobile ? 20 : undefined,
            },
            stepIcon: {
              fontSize: isMobile ? "1rem" : "2rem",
              height: isMobile ? 20 : undefined,
              width: isMobile ? 20 : undefined,
            },
            stepLabel: {
              fontSize: "1.5rem",
              marginTop: isPhone ? 10 : undefined,
            },
          }}
        >
          <Stepper.Step label={t("appointments.specialist")}>
            <FirstStep />
          </Stepper.Step>
          {stepperFields.specialist && stepperFields.specialist.online && (
            <Stepper.Step label={t("appointments.format")}>
              <SecondStep />
            </Stepper.Step>
          )}
          <Stepper.Step label={t("appointments.dateTime")}>
            <ThirdStep />
          </Stepper.Step>
          <Stepper.Step label={t("appointments.summary")}>
            <FourthStep />
          </Stepper.Step>
        </Stepper>
      </Container>
      <Footer isVisible />
    </Fragment>
  );
}

export default BookingPage;
